<app-action-popup
  [(visible)]="visible"
  (onHidden)="visibleChange.emit(visible)"
  (onShowing)="resetColumnForm()"
  [title]="title"
  (onSave)="save()"
>
  <app-column-form [(columnFormData)]="columnForm"></app-column-form>
</app-action-popup>
